import subsidiaryCompanyService from '@rd-web-markets/shared/dist/services/subsidiary_company.service';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function ProjectSubsidiaryCompanies(_ref) {
  let {
    claimGroup,
    report,
    pageAccess,
    isUnderReview,
    handleSubmit,
    handleChange
  } = _ref;
  const [subsidiaryCompanies, setSubsidiaryCompanies] = useState([]);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const fetchSubsidiaryCompanies = async () => {
      try {
        const subsidiaryCompanies = await subsidiaryCompanyService.all(claimGroup.company_id);
        setSubsidiaryCompanies(subsidiaryCompanies);
      } catch (error) {
        // Handle API errors gracefully - set empty array
        setSubsidiaryCompanies([]);
        console.error('Error fetching subsidiary companies:', error);
      }
    };
    fetchSubsidiaryCompanies();
  }, [claimGroup.company_id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('select_subsidiary_company')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: "select",
    name: "subsidiary_company_id",
    onBlur: handleSubmit,
    onChange: handleChange,
    size: "md",
    value: report.subsidiary_company_id || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), subsidiaryCompanies.map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c.id,
      value: c.id
    }, c.name);
  })))));
}